import * as React from 'react';
import { Button, Col, List, Row } from "antd";
import SyncQueueItem, { SyncQueueItemData } from "./SyncQueueItem";
import { GlobalContext } from "../../../Contexts/GlobalContext";
import { useContext } from "react";
import SyncQueueError from "./SyncQueueError";

interface SyncQueueListProps {
  syncing: boolean;
  displayLoadMore: boolean;
  hasFetchError: boolean;
  errorMessage?: string;
  errorIsConnectivity?: boolean;
  syncCallback: Function;
  deleteCallback: Function;
  loadMoreCallback: Function;
  treetypesList: any;
  treesData: SyncQueueItemData[];
}

export default function SyncQueueList(props: SyncQueueListProps) {
  const {
    syncing,
    syncCallback,
    deleteCallback,
    loadMoreCallback,
    treetypesList,
    treesData,
    displayLoadMore,
    hasFetchError,
    errorMessage,
    errorIsConnectivity
  } = props;

  const [isButtonLoading, setIsButtonLoading] = React.useState<boolean>(false);
  // Tree photo the viewer was last opened on: its whole row is boxed, the others are not. The list is
  // remounted on every opening of the popup (see the `key` in SyncQueue), which is what keeps the box
  // from outliving a visit: the Modal does not re-render its children while it is hidden, so a mark left
  // in this state could not be cleared from the inside.
  const [viewedPhotoIdbId, setViewedPhotoIdbId] = React.useState<number | undefined>(undefined);

  const { contract } = useContext(GlobalContext);
  const language = contract && contract.preferences && contract.preferences.language;
  const hasData = treesData.length !== 0;

  return (
    <>
      {hasData &&
        <SyncQueueError
          syncCallback={syncCallback}
          syncing={syncing}
          hasFetchError={hasFetchError}
          errorMessage={errorMessage}
          errorIsConnectivity={errorIsConnectivity}
        />
      }
      <Row>
        <Col span={24}>
          <List
            itemLayout="horizontal"
            dataSource={treesData}
            renderItem={(item) => {
              return <SyncQueueItem
                {...item}
                language={language ? language : ''}
                highlighted={viewedPhotoIdbId === item.idbId}
                onPhotoClick={setViewedPhotoIdbId}
                onSync={syncCallback}
                onDelete={deleteCallback}
                treetypesList={treetypesList}
              />
            }}
          />
        </Col>
      </Row>
      {hasData && displayLoadMore &&
        <Row>
          <Col>
            <Button block loading={isButtonLoading} onClick={async () => {
              console.log('Load more');
              setIsButtonLoading(true);
              await loadMoreCallback();
              setIsButtonLoading(false);
              return;
            }}>
              Load more
            </Button>
          </Col>
        </Row>
      }
    </>
  );
}